import React from 'react';
//import DatePicker from 'react-date-picker';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';


var idLocale = require('moment/locale/pl');
moment.locale('pl', idLocale);


export const TopInputDate = (props) =>{

    return (
        <div className={props.horizontal? 'komponent-kalendarz horizontal':'komponent-kalendarz'}>
        <DatePicker
            selected={props.value}
            onChange={props.onChange}
            dateFormat={'YYYY-MM-DD'}
            locale={'pl'}
            disabled={props.disabled}
            className={'form-control'}
            showYearDropdown
            showMonthDropdown
            {...props}
        />
            {(props.withoutIcon)?'':<i className={'fa fa-calendar'}></i>}
        </div>
    )
}

TopInputDate.propTypes = {
    onChange: PropTypes.func.isRequired,
    value: PropTypes.object.isRequired,
    disabled: PropTypes.bool,
    horizontal:PropTypes.bool,
    withoutIcon:PropTypes.bool,
};

TopInputDate.defaultProps = {
    disabled: false,
    horizontal:false,
    withoutIcon:false,
};


/*export const TopInputDate = (props) => {
    return (
        <DatePicker
            className={'form-control'}
            onChange={props.onChange}
            value={props.value}
            locale={"pl-PL"}
            calendarIcon={<i className={'fa fa-calendar'}></i>}
            clearIcon={<i className={'fa fa-times'}></i>}
            disabled={props.disabled}
        />
    );
};

TopInputDate.propTypes = {
    onChange: PropTypes.func.isRequired,
    value: PropTypes.object.isRequired,
    disabled: PropTypes.bool,
};

TopInputDate.defaultProps = {
    disabled: false,
};*/



// WEBPACK FOOTER //
// ./src/componentsTopsa/inputs/TopInputs.js